import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { OccupationModal } from '../../../sharedcomponents/commonservice/occupation/Occupation/Occupation.Modal';

import { AppSettings } from '../../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { storedetail } from '../../../models/mywallet/store/mywallet.store.Modal';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class mywalletstore {
  private storeInfo = new ReplaySubject<any>();
  private storeInforeceipt = new ReplaySubject<any>();

  constructor(private http: Http, private utilserv: utilityService) {}
  // 1 Envolpe for
  getstorelistservice() {
    return this.utilserv.soapPostwithoutAction(this.getstorelistenvolpe(), AppSettings.get_saved_stores_url);
  }

  deletestoreservice(storemodal: storedetail) {
    return this.utilserv.soapPostwithoutAction(this.deletestorelistenvolpe(storemodal), AppSettings.get_saved_stores_url);
  }

  getstorelistenvolpe() {
    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                     <s:Header>
                                       <a:Action s:mustUnderstand="1">http://tempuri.org/IStoreWallet/GetStoreListT2Based</a:Action>
                                       <a:MessageID>urn:uuid:08f2ec86-b2d0-4076-b1ad-57f6a242c6fd</a:MessageID>
                                       <a:ReplyTo>
                                         <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                       </a:ReplyTo>
                                     </s:Header>
                                     <s:Body>
                                       <RequestBase xmlns="http://tempuri.org/">
                                         <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                         <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                         <d4p1:T1></d4p1:T1>
                                         <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                         </Session>
                                       </RequestBase>
                                     </s:Body>
                                   </s:Envelope>

                                     `;
    return envelope;
  }

  deletestorelistenvolpe(storeid) {
    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                 <s:Header>
                            <a:Action s:mustUnderstand="1">http://tempuri.org/IStoreWallet/DeleteStore</a:Action>
                            <a:MessageID>urn:uuid:46720797-b926-4b97-b450-c3b036d61407</a:MessageID>
                            <a:ReplyTo>
                            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                            </a:ReplyTo>
                        </s:Header>
                        <s:Body>
                            <StoreDetail xmlns="http://tempuri.org/">
                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.Wallet.Contracts.DataContracts" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                            </Session>
                            <StoreID>${storeid}</StoreID>
                            </StoreDetail>
                        </s:Body>
                        </s:Envelope>`;
    return envelope;
  }

  ///Store Data
  setStoreData(dataValues: any) {
    this.storeInfo.next(dataValues);
  }

  getStoreData(): Observable<any> {
    return this.storeInfo.asObservable();
  }

  setStoreInforeceiptData(dataValues: any) {
    this.storeInforeceipt.next(dataValues);
  }

  getStoreInforeceiptData(): Observable<any> {
    return this.storeInforeceipt.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/mywallet/store/mywallet.store.service.ts